import { render, staticRenderFns } from "./xt-success.vue?vue&type=template&id=1bdbefa2&scoped=true&"
import script from "./xt-success.vue?vue&type=script&lang=js&"
export * from "./xt-success.vue?vue&type=script&lang=js&"
import style0 from "./xt-success.vue?vue&type=style&index=0&id=1bdbefa2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bdbefa2",
  null
  
)

export default component.exports